import {
  SettingOutlined,
  TrophyOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { Button, Col, Collapse, Space, Tag, Typography } from 'antd'
import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import {
  getLoyaltyTiers,
  selectLoyaltyTiers,
} from '../../store/LoyaltyTierReducer'
import { ProviderCard } from './ProviderCard'

const { Title } = Typography

const LoyaltyTierCardList = () => {
  const loyaltyTiers = useAppSelector(selectLoyaltyTiers())
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getLoyaltyTiers(initialQuery))
  }, [dispatch])

  const [activeKey, setActiveKey] = useState<string | undefined>(undefined)
  return loyaltyTiers.map((loyaltyTier) => (
    <Col span={24} key={loyaltyTier.id}>
      <Collapse
        className="loyalty-tier-collapse"
        collapsible={'disabled'}
        activeKey={activeKey}
        expandIcon={() => undefined}
        style={{ border: 0 }}
        items={[
          {
            key: loyaltyTier.id,
            label: (
              <Space
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Title className="m-0" level={5}>
                  <Space size={10}>
                    <TrophyOutlined />
                    {loyaltyTier.title}
                  </Space>
                </Title>
                <Space>
                  {loyaltyTier.users != undefined && (
                    <Tag icon={<UserOutlined />} color={loyaltyTier.color}>
                      {loyaltyTier.users}
                    </Tag>
                  )}
                  <Button
                    onClick={() =>
                      setActiveKey(
                        activeKey == String(loyaltyTier.id)
                          ? undefined
                          : String(loyaltyTier.id)
                      )
                    }
                    icon={<SettingOutlined />}
                  />
                </Space>
              </Space>
            ),

            children: (
              <Space direction="vertical" className="w-full" size="large">
                {loyaltyTier.providers.map((loyaltyTierProvider) => (
                  <ProviderCard
                    key={loyaltyTierProvider.id}
                    loyaltyTier={loyaltyTier}
                    loyaltyTierProvider={loyaltyTierProvider}
                  />
                ))}
              </Space>
            ),
          },
        ]}
      />
    </Col>
  ))
}

type CardListType = { CardList: typeof LoyaltyTierCardList }

export { LoyaltyTierCardList, type CardListType }
